<template>
  <b-jumbotron header-level="4">
    <template #header>
      <p :style="headerStyle">{{ title }}</p>
    </template>
    <template #lead>
      <p>{{ message }}</p>
    </template>
    <hr class="my-4" />
    <b-button v-if="hasAccess" variant="success" :href="fileUrl">Download</b-button>
  </b-jumbotron>
</template>

<script>
  export default {
    name: 'DocumentSecurity',
    data() {
      return {
        message: '',
        hasAccess: false,
        title: 'Checking file access...',
        loading: false,
        headerStyle: { color: 'orange' },
        fileUrl: '',
        fileName: '',
      };
    },
    created() {
      this.getAccessPermission();
    },
    methods: {
      async getAccessPermission() {
        this.loading = true;
        let responseId = this.$route.params.responseId;
        try {
          let response = await axios.get(`/api/get-access-permission/${responseId}`);
          this.hasAccess = response.data['hasAccess'];
          this.title = response.data['message'];
          if (this.hasAccess) {
            this.fileUrl = response.data['fileUrl'];
            this.fileName = response.data['fileName'];
            this.headerStyle.color = 'green';
            this.message = `You are now authorized to download ${this.fileName}. If the download hasn't started, click on the download button.`;
            window.open(this.fileUrl, '_blank');
          } else {
            this.headerStyle.color = 'red';
            this.message = 'You do not have access to download this file.';
          }
        } catch (error) {
          this.handleError(
            error,
            'Something went wrong while fetching the access permissions, please contact the support team.',
            `Error code: (${error.response.status})`,
          );
        }
        this.loading = false;
      },
      handleError(error, message, title) {
        this.$bvToast.toast(message, {
          title: title,
          autoHideDelay: 5000,
          appendToast: true,
          variant: `danger`,
        });
        console.error(error);
      },
    },
  };
</script>
